import React, {useState} from 'react';
import Modal from "react-responsive-modal";
import {validateMode} from "./commonExports"

import ModalLearningJournal from "./ModalLearningJournal";

export const LearningJournalModalModes = {
    SELECT: 'select',
    LOADING: 'loading',    // Internal mode, not to be used as initial state
}

const useModalLearningJournal = (onSaveCompleted) =>
{
    const MODAL_EMPTY_STATE = { openState: false, mode: 'none', flags: [], alds: null, coels: null, child_id: null, learning_journal_ald: null, date_from: null, date_to: null  };

    const [dialog, setDialog]  = useState ( MODAL_EMPTY_STATE)  ;

    const onClickActivate = ( { mode, child_id, flags, alds, coels, learning_journal_ald, date_from, date_to } ) =>
    {
        validateMode( mode, LearningJournalModalModes ) ;

        setDialog ({ openState: true, mode: mode, flags: flags, alds: alds, coels: coels, child_id: child_id, learning_journal_ald: learning_journal_ald, date_from: date_from, date_to: date_to  });
    }

    const onCloseModal = () =>
    {
        setDialog (MODAL_EMPTY_STATE);
    };

    const onSaveComplete = ( result ) =>
    {
        // Close the dialog
        setDialog (MODAL_EMPTY_STATE);

        // Tell the parent we're done
        onSaveCompleted( result ) ;
    };

    const render = () =>
    {
        return (
            <Modal center focusTrapped={false} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                { dialog.mode !== 'none' && < ModalLearningJournal child_id={dialog.child_id} flags={dialog.flags} alds={dialog.alds} coels={dialog.coels}
                                                                   learning_journal_ald={dialog.learning_journal_ald} date_from={dialog.date_from} date_to={dialog.date_to}
                                                                   onSaveCompleted={onSaveComplete}
                                                                   width={'650px'}
                                                                   onClose={onCloseModal} title="Generate Learning Journal" mode={dialog.mode} /> }
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;

}

export default useModalLearningJournal;